/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_Any_ProfileInputs */

const en_task_settings_any_profile = /** @type {(inputs: Task_Settings_Any_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any profile`)
};

const pt_br2_task_settings_any_profile = /** @type {(inputs: Task_Settings_Any_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer perfil`)
};

/**
* | output |
* | --- |
* | "Any profile" |
*
* @param {Task_Settings_Any_ProfileInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_any_profile = /** @type {((inputs?: Task_Settings_Any_ProfileInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_Any_ProfileInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_any_profile(inputs)
	return pt_br2_task_settings_any_profile(inputs)
});